import {
    Injectable,
    ViewContainerRef,
    ComponentFactoryResolver,
} from '@angular/core';
import { ReportTypes } from '../enums/report-types';
import { ReportsEstudioService } from './reports-estudio.service';
import { ApiService } from 'app/modules/common/services/api.service';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';
import { EstudioParameters, EstudioReports } from '../entities/estudio-model';
import { CompanyAttribute } from '../entities/company-attribute.model';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EstudioReportsComponent } from '../components/estudio-report-view/reports-view/estudio-reports/estudio-reports.component';
import { LeaveReportType } from 'app/modules/common/enums/leave-report-enums';
import _ from 'lodash';
import { LeaveSelectionFilters } from 'app/modules/selection-generic/entities/leave-search-modal';
import Utils from 'app/Utils';

@Injectable({
    providedIn: 'root',
})
export class ReportsCommonService {
    public SelectedReport: ReportTypes;
    public ReportTypeList: any[];

    public estudioReportContainerRef: ViewContainerRef;
    public estudioReportElements = [];

    public selectedAttributeList = new Array<CompanyAttribute>();
    public selectedAttributeIDs: any[];

    public isTemplate = false;
    public isLoading = false;
    public estudioReport: EstudioReports;
    public reportList: any[];
    public empresaId: number;
    public templateId: number;
    public trabajadorId: number;
    public leaveReportType: LeaveReportType = LeaveReportType.ListadoBaja;
    public leaveSelectionModal: LeaveSelectionFilters = new LeaveSelectionFilters();
    currentUser: any;
    permissionList: any;

    constructor(
        private _componentFactoryResolver: ComponentFactoryResolver,
        private _reportsEstudioService: ReportsEstudioService,
        private _apiService: ApiService,
        private _sharedService: SharedService,
    ) {
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
        if (this.currentUser) {
            this.permissionList = this.currentUser.permissionIds;
        }
    }

    public initReportTypeList(): void {
        this.ReportTypeList = [
            { id: ReportTypes.Estudio, isPermit: this.permissionList.includes(805), viewValue: 'Estudio' },
            {
                id: ReportTypes.Resumenes,
                isPermit: this.permissionList.includes(858),
                viewValue: 'Resumenes',
            },
            {
                id: ReportTypes.Leave,
                isPermit: this.permissionList.includes(806) ,
                viewValue: 'Bajas Activas',
            },
            {
                id: ReportTypes.Listados,
                isPermit: this.permissionList.includes(898) || this.permissionList.includes(835) ||
                        this.permissionList.includes(307) || this.permissionList.includes(817) ||
                        this.permissionList.includes(831) || this.permissionList.includes(898) ||
                        this.permissionList.includes(855) || this.permissionList.includes(857),
                viewValue: 'Listados',
            },
        ];
        this.SelectedReport = ReportTypes.Estudio;
    }

    public refreshEstudioReportElements(): void {
        let isFirstCycle = true;
        if (this.selectedAttributeList.length === 0) {
            const currentContentLength = this.estudioReportContainerRef.length;
            for (let index = 0; index < currentContentLength; index++) {
                if (index !== 0) {
                    this.estudioReportContainerRef.remove(index);
                    this.estudioReportElements.splice(index, 1);
                    this._reportsEstudioService.estudioTemplate.ReportList.splice(
                        index,
                        1
                    );
                }
            }
        }

        this.selectedAttributeList.forEach((attribute) => {
            const title = attribute.attributeText;
            let existingReportElement =
                this._reportsEstudioService.estudioTemplate.ReportList.filter(
                    (r) => r.Title === title
                )[0];

            if (isFirstCycle) {
                const currentContentLength =
                    this.estudioReportContainerRef.length;
                for (let index = 0; index < currentContentLength; index++) {
                    if (index !== 0) {
                        this.estudioReportContainerRef.remove(index);
                        this.estudioReportElements.splice(index, 1);
                        this._reportsEstudioService.estudioTemplate.ReportList.splice(
                            index,
                            1
                        );
                    }
                }
                isFirstCycle = false;
            }

            if (existingReportElement === undefined) {
                existingReportElement = null;
            }
            this.addEstudioReportElement(
                title,
                true,
                existingReportElement,
                attribute.columnNumber
            );
        });
    }

    public refreshSelectedAttributeIds(): void {
        const invalidIds = new Array<number>();
        this.selectedAttributeList.forEach((value, index) => {
            const existingAttribute =
                this._reportsEstudioService.estudioTemplate.ReportList.filter(
                    (e) => e.Title === value.attributeText
                )[0];
            if (!existingAttribute) {
                invalidIds.push(value.columnNumber);
            }
        });

        invalidIds.forEach((id) => {
            const attrElement = this.selectedAttributeList.filter(
                (e) => e.columnNumber === id
            )[0];
            const attrIndex = this.selectedAttributeList.indexOf(attrElement);
            this.selectedAttributeList.splice(attrIndex, 1);

            const idIndex = this.selectedAttributeIDs.indexOf(id);
            this.selectedAttributeIDs.splice(idIndex, 1);
        });
    }

    public addEstudioReportElement(
        sectionName: string,
        canDelete: boolean = true,
        reportValues: EstudioReports = null,
        attributeIndex: number = null
    ): void {
        const componentFactory =
            this._componentFactoryResolver.resolveComponentFactory(
                EstudioReportsComponent
            );
        const component =
            this.estudioReportContainerRef.createComponent(componentFactory);
        component.instance.canDelete = canDelete;
        component.instance.sectionName = sectionName;
        this.estudioReportElements.push(component);

        if (reportValues === null) {
            reportValues = new EstudioReports();
        }

        reportValues.Title = sectionName;
        reportValues.CompanyId = parseInt(localStorage.getItem('Empresa'));
        reportValues.AttributeName =
            sectionName == 'Empresa' ? '' : sectionName;
        reportValues.AttributeIndex =
            sectionName == 'Empresa' ? -1 : attributeIndex;
        component.instance.estudioReport = reportValues;
        component.instance.intiReportList();

        // if adding empresa section, remove existing empresa section
        if (sectionName == 'Empresa') {
            this._reportsEstudioService.estudioTemplate.ReportList =
                this._reportsEstudioService.estudioTemplate.ReportList.filter(
                    (e) => e.Title !== 'Empresa'
                );
        }

        this._reportsEstudioService.estudioTemplate.ReportList.push(
            reportValues
        );
        this._reportsEstudioService.estudioTemplate.ReportList = _.uniqBy(
            this._reportsEstudioService.estudioTemplate.ReportList,
            (r) => r.AttributeIndex
        );
    }

    public removeEstudioReportElement(
        reportElement: EstudioReportsComponent
    ): void {
        const component = this.estudioReportElements.find(
            (c) => c.instance.sectionName === reportElement.sectionName
        );
        const componentIndex = this.estudioReportElements.indexOf(component);

        if (componentIndex !== -1) {
            this.estudioReportContainerRef.remove(
                this.estudioReportContainerRef.indexOf(component)
            );
            this.estudioReportElements.splice(componentIndex, 1);

            const report =
                this._reportsEstudioService.estudioTemplate.ReportList.filter(
                    (r) => r.Title === reportElement.sectionName
                )[0];
            const index =
                this._reportsEstudioService.estudioTemplate.ReportList.indexOf(
                    report
                );
            this._reportsEstudioService.estudioTemplate.ReportList.splice(
                index,
                1
            );

            const attribute = this.selectedAttributeList.filter(
                (a) => a.attributeText === reportElement.sectionName
            )[0];
            const attributeIndex =
                this.selectedAttributeList.indexOf(attribute);
            this.selectedAttributeList.splice(attributeIndex, 1);

            const aID = this.selectedAttributeIDs.filter(
                (a) => a === attribute.columnNumber
            )[0];
            const aIndex = this.selectedAttributeIDs.indexOf(aID);
            this.selectedAttributeIDs.splice(aIndex, 1);
        }
    }

    public generateReport(): Observable<any> {
        let url = '';
        let isReportSelectionValid = false;
        let postBodyParam: any;
        switch (this.SelectedReport) {
            case ReportTypes.Estudio:
                const parameters =
                    this._reportsEstudioService.getParameterModel();
                const reportList = this._reportsEstudioService.getReportList();
                isReportSelectionValid = this.validateEstudioReportParameters(
                    parameters,
                    reportList
                );
                url = `${API.Report.generateEstudiosReport}`;
                postBodyParam = {
                    ReportList: reportList,
                    Parameters: parameters,
                };
                break;

            case ReportTypes.Resumenes:
                // Not Developed
                break;
            case ReportTypes.Leave:
                const parameter = '';
                url = `${API.LeaveReport.generateLeaveReport}`;
                // postBodyParam = {
                //     "TemplateId": this.templateId, //19555175, //100436043,//19555175,
                //     "EmpresaId": this.empresaId,   //26448981,
                //     "TrabajadorId": this.trabajadorId,
                //     "LeaveFilters": this._selectionService.leaveSelectionModal,
                // };
                postBodyParam = this.getLeaveReportRequestBody();

                for (var key in this.leaveSelectionModal) {
                    if (key != "Idioma") {
                        if (postBodyParam.LeaveFilters[key] === undefined) {
                                postBodyParam.LeaveFilters[key] = this.leaveSelectionModal[key];
                        }else{
                            if (postBodyParam.LeaveFilters[key] == "") {
                                postBodyParam.LeaveFilters[key] = this.leaveSelectionModal[key];
                            }
                        }
                    }
                }                
                break;

            case ReportTypes.Listados:
                // const params ="" //this._listadosService.getParameterModel();
                //const selectedReport ="" //this._listadosService.getReportList();
                // isReportSelectionValid = this.validateEstudioReportParameters(params, selectedReport);
                //url = `${API.Report.generateEstudiosReport}`;
                // postBodyParam = {
                //     "ReportList": selectedReport,
                //     "Parameters": params
                // };
                break;
            default:
                break;
        }
        if (this.SelectedReport == ReportTypes.Leave) {
            return this._apiService.post(url, postBodyParam, false);
        }
        if (isReportSelectionValid) {
            return this._apiService.post(url, postBodyParam, false);
        }
    }

    private getLeaveReportRequestBody(): {
        TemplateId: number;
        leaveReportType: LeaveReportType;
        EmpresaId: number;
        TrabajadorId: number;
        LeaveFilters: any;
    } {
        return {
            TemplateId: this.templateId, //19555175, //100436043,//19555175,
            leaveReportType: this.leaveReportType,
            EmpresaId: this.empresaId, //26448981,
            TrabajadorId: this.trabajadorId,
            LeaveFilters: JSON.parse(localStorage.getItem('leave-report-pharms')),
            // LeaveFilters: this._selectionService.leaveSelectionModal,
        };
    }

    public saveReportTemplate(templateName: string): Observable<RestResponse> {
        switch (this.SelectedReport) {
            case ReportTypes.Estudio:
                const template = this._reportsEstudioService.getTemplateModel();
                template.Name = templateName;
                const url = `${API.Report.saveReportTemplate}`;
                return this._apiService.post(url, template);
                break;

            case ReportTypes.Leave:
                // Not Developed
                break;

            case ReportTypes.Resumenes:
                // Not Developed
                break;

            case ReportTypes.Listados:
                // Not Developed
                break;

            default:
                break;
        }
    }

    public updateReportTemplate(): Observable<RestResponse> {
        switch (this.SelectedReport) {
            case ReportTypes.Estudio:
                const template = this._reportsEstudioService.getTemplateModel();
                const url = `${API.Report.updateReportTemplate}?TemplateId=${template.TemplateId}`;
                return this._apiService.put(url, template);
                break;

            case ReportTypes.Leave:
                // Not Developed
                break;

            case ReportTypes.Resumenes:
                // Not Developed
                break;

            case ReportTypes.Listados:
                // Not Developed
                break;

            default:
                break;
        }
    }

    public loadReportTemplate(templateId: number): Observable<RestResponse> {
        switch (this.SelectedReport) {
            case ReportTypes.Estudio:
                const url = `${API.Report.loadReportTemplate}`;

                return this._apiService.get(url);
                break;

            case ReportTypes.Resumenes:
                // Not Developed
                break;

            case ReportTypes.Leave:
                // Not Developed
                break;

            case ReportTypes.Listados:
                // Not Developed
                break;

            default:
                break;
        }
    }

    public removeReportTemplate(): Observable<RestResponse> {
        switch (this.SelectedReport) {
            case ReportTypes.Estudio:
                const template = this._reportsEstudioService.getTemplateModel();
                const url = `${API.Report.deleteReportTemplate}?TemplateId=${template.TemplateId}`;
                return this._apiService.delete(url);
                break;

            case ReportTypes.Leave:
                // Not Developed
                break;

            case ReportTypes.Resumenes:
                // Not Developed
                break;

            case ReportTypes.Listados:
                // Not Developed
                break;

            default:
                break;
        }
    }

    public getAttributeList(companyId: number): Observable<RestResponse> {
        const url = `${API.Report.getCompanyAttributes}?companyId=${companyId}`;
        return this._apiService.get(url);
    }

    public validateEstudioReportParameters(
        eStudioParam: EstudioParameters,
        reportList: EstudioReports[]
    ): boolean {
        let result = false;
        let errorMsg = '';

        //NOTE : At lease 1 report option should be selected
        let isReportSelectionValid =
            reportList.filter(
                (a) =>
                    a.AbsAcumulado ||
                    a.AbsMensual ||
                    a.BajasActivas ||
                    a.BajasComunicadas ||
                    a.CuadroDeMando ||
                    a.DiagnEdad ||
                    a.DiagnEdadGenero ||
                    a.DiagnGenero ||
                    a.Diagnostico ||
                    a.DiasDeLaSemana ||
                    a.DuracionMedia ||
                    a.Edades ||
                    a.GapsDeBaja ||
                    a.Genero ||
                    a.Portada
            ).length > 0;

        if (
            localStorage.getItem('Empresa') == null ||
            localStorage.getItem('Empresa') == 'null' ||
            localStorage.getItem('Empresa') == ''
        ) {
            errorMsg = 'Se debe introducir la empresa o delegación.';
        } else if (
            eStudioParam.ReportStartDate == null ||
            eStudioParam.ReportStartDate == '' ||
            eStudioParam.ReportEndDate == null ||
            eStudioParam.ReportEndDate == ''
        ) {
            errorMsg = 'Se debe introducir el periodo';
        } else if (
            this._reportsEstudioService.getParameterModel().LeaveTypes ==
                null ||
            this._reportsEstudioService.getParameterModel().LeaveTypes == ''
        ) {
            result = false;
        } else if (
            this._reportsEstudioService.getParameterModel().CompanyLevels ==
                null ||
            this._reportsEstudioService.getParameterModel().CompanyLevels == ''
        ) {
            result = false;
        } else if (!isReportSelectionValid) {
            errorMsg =
                'Selección de informe no válida. Debe seleccionar al menos un informe.';
        } else {
            result = true;
            errorMsg = '';
        }
        if (!result && errorMsg != '') {
            this._sharedService.ShowSnackBar(errorMsg, '', 5000);
        }
        return result;
    }

    public setFiltros(leaveSelectionModal): void{
        this.leaveSelectionModal = leaveSelectionModal;
    }
}
